// src/index.ts
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["Pageview"] = "page";
  EventType2["Event"] = "event";
  EventType2["Social"] = "social";
  return EventType2;
})(EventType || {});
var createAnalytics = (handlers) => {
  const track = (type, data) => {
    for (const i in handlers) {
      handlers[i](type, data);
    }
  };
  return track;
};
var src_default = createAnalytics;

export { EventType, src_default as default };
